import styled from 'styled-components';
import React, { useState, useEffect, useRef } from "react";
import Multicenter_studies from "./Multicenter_studies.js";
import SNUG_DB from "./SNUG_DB.js";
import Super_GUC from "./Super_GUC.js";
import AI_research from "./AI_Research.js";
function Research({match}){
    const Page=match.params.name;
    if(Page =="multicenter_studies"){
        return (<Multicenter_studies/>);
    }
    else if(Page == "SNUG_DB"){
        return (<SNUG_DB/>);
    }
    else if(Page == "super_GUC"){
        return(<Super_GUC/>);
    }
    else if(Page =="ai_research"){
        return(<AI_research/>)
    }
    else {
        return(<div>404 페이지를 찾을 수 없습니다. </div>)
    }
}  


export default Research;